import { IAction } from "store/store.interface";
import { SET_SHIPMENT_SERVICES, SET_SELECTED_SHIPMENTS, SET_MARKETPLACE_VALUES } from "store/store.types";

export const SHIPMENT_SERVICES_INITIAL_STATE: IShipmentTypes={
  shipmentServices:[],
  selectedShipments:[],
  marketplaceValues: {}
};

export type Operation = "in" | "equal" | "notIn" | "allSeller"
export interface IMarketPlaceRadios {
  [key: string]: Operation;
}

export interface IShipmentServices{
  id?:number;
  name?: string;
  displayName?: string;
  sellerType?:string;
}
export interface IShipmentTypes {
  shipmentServices?:IShipmentServices[];
  selectedShipments?:ISelectedShipments[];
  marketplaceValues?: IMarketPlaceRadios;
}
export interface ISelectedShipments {
  label: string;
  value: string;
  sellerType?: string;
};

const shipmentServicesReducer = (
  state: IShipmentTypes = SHIPMENT_SERVICES_INITIAL_STATE,
  action: IAction
) => {
  switch (action.type) {
    case SET_SHIPMENT_SERVICES:
      return {...state,
        shipmentServices:action.payload};
    case SET_SELECTED_SHIPMENTS: {
      return {...state,
        selectedShipments:action.payload
      };
    }
    case SET_MARKETPLACE_VALUES: {
      return {...state,
        marketplaceValues:action.payload
      };
    }
    default:
      return state;
  }
};

export default shipmentServicesReducer;
